export default "ui-datalist{display:none}\n";